import { Component, inject, Input } from '@angular/core';
import { Subscription, interval } from 'rxjs';
import { GatewayConnectionService } from 'src/app/services/apiHandler/gateway-connection/gateway-connection.service';
import { IconHelper } from 'src/app/services/helper/icon-helper';
import { TranslateService } from '@ngx-translate/core';
import { GlobalService } from 'src/app/services/helper/global-helper';
import { KeycloakService } from 'keycloak-angular';
import { Router } from '@angular/router';
import { RoleService } from 'src/app/services/helper/role-handling-helper';
import { MatSnackBar } from '@angular/material/snack-bar';
import { environment } from 'src/environments/environment';
import { IdleTimerService } from 'src/app/services/helper/idleTimer/idle-timer.service';


@Component({
    selector: 'app-toolbar',
    templateUrl: './toolbar.component.html',
    styleUrls: ['./toolbar.component.scss'],
})
export class ToolbarComponent {
    public backendAlive: boolean = true;
    public connected: boolean = false;
    public machinenumber: string = "";
    connectionMomLost: boolean = false;
    occurred: boolean = false;
    snackbar = inject(MatSnackBar);
    currentLanguage = 'en'; 

    public env = environment;

    @Input() sidenav: any;

    //for email
    user = '';
    variables = '';
    roles = '';
    machineName = '';
    machineLine = '';
    engine = '';
    swVersions = [];

    constructor(public apiGwConnection: GatewayConnectionService, public iconHelper: IconHelper, private translate: TranslateService, public global: GlobalService, public roleService: RoleService, private keycloak: KeycloakService, private router: Router, private idleService: IdleTimerService) {
        let aliveCheckSub: Subscription = interval(5000).subscribe(() => {
            this.backendAlive = this.apiGwConnection.backendAlive;
            if(!this.backendAlive){
                this.connectionMomLost = true;
            }
            if(this.occurred && this.backendAlive && this.connectionMomLost) {
                this.connectionMomLost = false;
                this.global.error.next({occurred: false});
                this.snackbar.open(this.translate.instant('ERROR.BACKEND_BACK'), this.translate.instant('ERROR.ACTION'), {verticalPosition: 'top', panelClass: 'error-snackbar', duration: 2000});
                this.apiGwConnection.registerUser().subscribe();
            }
        });
        this.global.machineNumber.subscribe({
            next: newValue => {this.machinenumber = newValue.number;}
        });
        this.global.variables.subscribe({
            next: newValue => {this.connected = newValue.connected;}
        });
        this.global.error.subscribe({
            next: newValue => {this.occurred = newValue.occurred;}
        });
        this.global.user.subscribe({
            next: newValue => {
                this.user = newValue.name;
                this.roles = newValue.roles;
            },
        });
        this.global.variables.subscribe({
            next: (newValue) => {this.variables = newValue;},
        }); 
        this.global.machineInfos.subscribe({
            next: newValue => {
                this.machineName = newValue.name;
                this.machineLine = newValue.line;
                this.engine = newValue.engine;
            }
        });
        this.global.swVersion.subscribe({
            next: newValue => {
                this.swVersions = newValue.versions;
            }
        });
    }

    public logOut(){
        this.apiGwConnection.disconnectFromGateway().subscribe();
        this.keycloak.logout();
    }

    setLanguage(lang: string) {
        this.currentLanguage = lang;
    }

    public onSelected(value: string){
        this.translate.use(value);
        this.currentLanguage = value;
        if(this.router.url != "/comissioning") {
            this.global.swVersion.next({loaded: false, versions: []});
        }
    }

    public switchMachine(){
        this.idleService.stopWatching();
        this.apiGwConnection.disconnectFromGateway().subscribe();
        this.global.machineNumber.next({ number: '', id: '', series: ''});
        this.global.machineInfos.next({line: '', name:'', engine: ''});
        this.global.variables.next({ connected: false});
        this.global.swVersion.next({loaded: false, versions: []});
        this.global.comission.next({enabled: false});
        this.router.navigateByUrl("");
        setTimeout(() => {
            this.global.savedParameters.next({locked: false, parameters: []});
        }, 1000);        
    }

    public reportError() {
        let flattenString = `User: ${this.user}%0AMachine: ${this.machinenumber}%0AMachineline: ${this.machineLine}%0AEngine: ${this.engine}%0AMachinename: ${this.machineName}%0ASW-Versions: ${this.swVersions}%0AVariables: ${JSON.stringify(this.variables)}%0APage:${JSON.stringify(window.location)}%0ARoles: ${JSON.stringify(this.roles)}`;

        window.open(
            'mailto:remotediagnose@sennebogen.de?Subject=Fehlerreport Remote Diagnose&body=Main Information:%0A' +
                flattenString +
                '%0A====================================%0AHier Nachricht hinzufügen:',
            '_top'
        );
    }

    public quickstart() {
        window.open('../../../assets/quickstart.pdf', '_blank');
    }
}
